import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-5 mb-3 md:mb-4">
            <div className="lg:w-[320px]">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-fill text-xl text-primary-500"></i>
                </div>
                <span className="text-lg font-heading font-bold text-foreground-950">八戒影院</span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                八戒影院提供海量高清免费影视在线观看，无需缓冲流畅播放。涵盖电视剧全集、电影大全及最新影视资源，每日同步更新，免费畅享。
              </p>
            </div>

            <div className="flex flex-wrap gap-8 flex-1 justify-between">
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-3">影视分类</h4>
                <div className="flex flex-col gap-2">
                  {[
                    { name: "动作片", slug: "action" },
                    { name: "喜剧片", slug: "comedy" },
                    { name: "科幻片", slug: "scifi" },
                    { name: "爱情片", slug: "romance" },
                    { name: "恐怖片", slug: "horror" },
                  ].map((c) => (
                    <Link
                      key={c.slug}
                      to={`/category/${c.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {c.name}
                    </Link>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-3">热门推荐</h4>
                <div className="flex flex-col gap-2">
                  {[
                    { name: "电视剧", slug: "tvseries" },
                    { name: "动画片", slug: "anime" },
                    { name: "剧情片", slug: "drama" },
                    { name: "综艺", slug: "variety" },
                  ].map((c) => (
                    <Link
                      key={c.slug}
                      to={`/category/${c.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {c.name}
                    </Link>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-3">关于我们</h4>
                <div className="flex flex-col gap-2">
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    品牌介绍
                  </Link>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    用户口碑
                  </Link>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    联系我们
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-background-200/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 八戒影院 - 高清免费在线观看。本站所有资源均来自互联网，仅供交流学习使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}